import { Checkbox, FormControlLabel, FormControlLabelProps } from '@mui/material';
import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form';

interface CheckboxControllerProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<ControllerProps<TFieldValues, TName>, 'render'> {
  label?: FormControlLabelProps['label'];
  slotProps?: {
    formControlLabel?: Partial<FormControlLabelProps>;
  };
}

export const CheckboxController = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: CheckboxControllerProps<TFieldValues, TName>,
) => {
  const { label, slotProps, ...controllerProps } = props;
  return (
    <Controller
      {...controllerProps}
      render={({ field }) => (
        <FormControlLabel
          {...field}
          value={field.value ?? ''}
          label={label}
          control={<Checkbox />}
          {...slotProps?.formControlLabel}
        />
      )}
    />
  );
};
